// The embed script's mode probe (see `runModeProbe` there) loads this
// document with `?probe=1` for one answer — which mode the channel is in —
// and nothing else may happen on that load: no React, no socket, no
// identity, nothing stored. So the branch is taken before the app is even
// imported; `probe.ts` is its own chunk and the app's never downloads.
if (new URLSearchParams(window.location.search).get('probe') === '1') {
  import('./probe').then(({ runModeProbe }) => runModeProbe())
} else {
  import('./bootstrap')
}
